import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../../hooks/UseAuth";


export const ProtectedRoute = ({allowedRoles} : {allowedRoles : number[]}) => {
    const {user} = useAuth();
    const location = useLocation();

    if(user && allowedRoles.includes(user.role)){
        return <Outlet/>;
    }

    return user ? <Navigate to="/unauthorized" state={{from: location}} replace/> :
     <Navigate to="/login" state={{from: location}} replace/>;
};